export default {
   divideEqually: function(total, nbOfParts, precision) {
      let part = this.round(total / nbOfParts, precision);

      let parts = [];

      let partTotal = this.round(total, 2);
      for(let i = 0; i < nbOfParts; i++)
      {
         parts[i] = part;

         partTotal -= part;
      }

      if(partTotal !== 0) {
         parts[nbOfParts - 1] = this.round(parts[nbOfParts - 1] + partTotal, 2);
      }

      return parts
   },
   round: function(number, precision) {
      let pow = Math.pow(10, precision);
      return Math.round((number + Number.EPSILON) * pow) / pow
   },
   parse: function(numberStr, defaultNumber, precision, thousandDelimiter, decimalDelimiter) {
      let number = parseFloat((numberStr || "").replace(thousandDelimiter, "").split(decimalDelimiter).join("."));
      if(isNaN(number)) {
         return this.round(defaultNumber, 2);
      }
      return this.round(number, precision);
   },
   format: function(number, precision, thousandDelimiter, decimalDelimiter) {
      return number.toFixed(precision).split(".").join(decimalDelimiter);
   }
}